import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "footer-inner" }
const _hoisted_2 = { style: {"margin-left":"10px"} }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterMenu',
  setup(__props) {

const isFinance = computed(() => {
  if (typeof window === 'undefined') return false
  return window.location.hostname === 'finance.artrofimov.xyz'
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      (isFinance.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Art Finance · artrofimov.xyz · Amsterdam", -1)),
            _createElementVNode("span", null, [
              _cache[3] || (_cache[3] = _createTextVNode(" Not financial advice. Structural measurement, not prediction. ", -1)),
              _createElementVNode("span", _hoisted_2, [
                _createVNode(_component_router_link, { to: "/live" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("Live scores", -1)
                  ]))]),
                  _: 1
                }),
                _cache[1] || (_cache[1] = _createElementVNode("span", { style: {"opacity":"0.6"} }, "  ", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("a", { href: "https://artrofimov.xyz" }, "← Main site", -1))
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "Art · Structural Health Monitoring · Amsterdam", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "Measurement instrument, not prediction system.", -1))
          ], 64))
    ])
  ]))
}
}

})